import Form from './Form';
export default Form;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/antd/es/form/index.js
// module id = 640
// module chunks = 0